import StatusPills from "../../StatusPills";
import { ClientFileType } from "../../../types/clientFileType";
import { FileStatusType } from "../../../types/fileStatusType";

const StatusCell = ({ files }: { files: ClientFileType[] }) => {
  return (
    <>
      {files
        .filter(
          (f: { id: string; status: FileStatusType }) => f.status !== "Archived"
        )
        .map((f: { id: string; status: FileStatusType }) => (
          <StatusPills key={f.id} status={f.status} />
        ))}
    </>
  );
};

export default StatusCell;
